<template lang="pug">
.basketItems(v-if="itemsCount || isLoading")
  .header
    .sum {{ itemsCount }} {{ itemsCountText }}
    .price Цена
  basket-item(
    v-for="item in items"
    :key="item.id"
    :item="item"
  )
  .clear(@click="onClearButtonClick") Очистить корзину
</template>

<script>
import pluralize from '@/_core/helpers/pluralize'
import { computed, inject } from 'vue'
import BasketItem from './BasketItem'
export default {
  components: { BasketItem },
  setup () {
    const store = inject('store')

    const itemsCount = computed(() => store.basket.data?.itemsCount)
    const items = computed(() => store.basket.data?.items ?? [])
    const isLoading = computed(() => store.basket.isLoading)

    const onClearButtonClick = () => store.basket.clear()

    const itemsCountText = pluralize(itemsCount.value, 'товар', 'товара', 'товаров')

    return { onClearButtonClick, items, isLoading, itemsCount, itemsCountText }
  }
}
</script>

<style lang="sass">
.basketItems
  width: calc(100% - 300px)
  display: flex
  flex-direction: column
  gap: 4*$u
  @media (max-width: $XSWidth)
    width: 100%
  .header
    display: flex
    align-items: center
    padding-right: 39*$u
    gap: 60px
    @media (max-width: $XLWidth)
      display: none
    .price
      @include font('t16-medium')
      color: $cDarkGrey
    .sum
      margin-right: auto
      font-family: GolosTextWebDemiBold, serif
      font-size: 20px
      line-height: 24px
  .clear
    font-family: GolosTextWebRegular
    font-weight: bold
    font-size: 14px
    cursor: pointer
    color: $cDarkGrey
    text-decoration: underline
</style>
